import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const playershopsApi = axios.create({
  baseURL: API_BASE_URL + "api/playershops",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
